module.exports = __webpack_public_path__ + "static/media/ios-send.1aa82080.svg";